export default {"textReadMore":"NExU5","btnSeeMore":"mNhPE","readMoreText":"Q6FlK","lines":"J3HIy"};